import Login from '../../pages/Login';
import Page2Fa from '../../pages/2fa';
import Page2FaApp from '../../pages/2fa/app';
import Page2FaAppRejected from '../../pages/2fa/app/rejected';

import { uuid } from '../../utils/helper';

export default [
  {
    name: 'Login',
    link: '/',
    id: uuid(),
    component: Login,
    react: true,
    public: true,
  },
  {
    name: 'Enter 6-digit code',
    link: '/2fa',
    id: uuid(),
    component: Page2Fa,
    react: true,
    public: true,
  },
  {
    name: '2FA with App',
    link: '/2fa/app',
    id: uuid(),
    component: Page2FaApp,
    react: true,
    public: true,
  },
  {
    name: '2FA with App Rejected',
    link: '/2fa-rejected',
    id: uuid(),
    component: Page2FaAppRejected,
    react: true,
    public: true,
  },
];
